import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@cotyorg/ccx-molecules/IconButton';

const generateIconButtonClassNames = ({ extraClass }) => classNames(
  'button--clear',
  'header__navigation-button',
  'header__nav-toggle', {
    [`${extraClass}`]: extraClass,
  },
);

const generateButtonText = ({
  isSelected,
  mobileNavButtonOpenText,
  mobileNavButtonCloseText,
}) => (
  isSelected ? mobileNavButtonCloseText : mobileNavButtonOpenText
);

const generateIconName = ({
  isSelected,
  closeIconSrc,
  hamburgerIconSrc,
}) => (isSelected ? closeIconSrc : hamburgerIconSrc);

const HeaderNavButton = ({
  extraClass,
  onClick,
  isSelected,
  closeIconSrc,
  hamburgerIconSrc,
  mobileNavButtonOpenText = '',
  mobileNavButtonCloseText = '',
  hamburgerIconWidth,
  hamburgerIconHeight,
}) => (
  <IconButton
    color="transparent"
    size="small"
    extraClass={generateIconButtonClassNames({ extraClass })}
    iconSrc={generateIconName({ isSelected, closeIconSrc, hamburgerIconSrc })}
    onClick={onClick}
    iconWidth={hamburgerIconWidth}
    iconHeight={hamburgerIconHeight}
  >
    <span className="show-for-sr">
      {
        generateButtonText({
          isSelected,
          mobileNavButtonOpenText,
          mobileNavButtonCloseText,
        })
      }
    </span>
  </IconButton>
);

HeaderNavButton.propTypes = {
  extraClass: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  closeIconSrc: PropTypes.string,
  hamburgerIconSrc: PropTypes.string,
  mobileNavButtonOpenText: PropTypes.string,
  mobileNavButtonCloseText: PropTypes.string,
  hamburgerIconWidth: PropTypes.number,
  hamburgerIconHeight: PropTypes.number,
};

export default HeaderNavButton;
